import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SI_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#SI_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SI_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SI_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.74 5.036s-2.105-.994-4.723-.994c-2.617 0-4.722.994-4.722.994s.234 3.995.604 6.11c.158.904.918 2.222 1.606 2.846.784.71 2.512 1.553 2.512 1.553.5-.345 1.436-.5 2.631-1.553 1.196-1.054 1.493-2.845 1.493-2.845l.599-6.111z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.462 4.905l.876.438-.601 6.023c-.211 1.274-.739 2.28-1.582 3.023a6.847 6.847 0 01-1.382.954c-.27.142-1.401.724-1.391.72-.113.054-.2.102-.27.15l-.108.075-.118-.058c-1.171-.57-2.264-1.338-2.806-1.83-.741-.672-1.523-2.047-1.69-3-.248-1.423-.472-3.384-.628-6.057l.787-.412c.156 2.653.343 4.768.588 6.166.145.827.865 2.095 1.522 2.691.486.44 1.269.929 2.345 1.46a3.03 3.03 0 01.216-.114c.003 0 .734-.326.989-.459.446-.233.86-.513 1.288-.89.748-.659 1.215-1.547 1.404-2.676l.56-6.204z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.541 11.024s.19.583.543 1.238c.519.137.836.13.937.018.29-.324 1.32-.463 1.513-.186.118.171.536.29.992.133l-.051.009c.08-.029.265-.103.38-.148l.092-.037c.172-.065.298-.098.427-.108a.924.924 0 01.48.096c.359.171.802.251 1.104.2.37-.644.634-1.216.634-1.216L10.836 9.34l-.697.757-1.16-1.653-.97 1.653-.744-.757-1.724 1.684zm1.015 1.99a5.488 5.488 0 01-.23-.336c.45.082.755.039.925-.151.08-.09.318-.177.589-.213a1.56 1.56 0 01.34-.013c.042.004.077.01.1.019.007.002.007.002 0-.009l-.002-.002c.207.296.769.454 1.299.262l-.051.009c.143-.044.401-.146.494-.182l.032-.013c.148-.056.249-.083.344-.09a.627.627 0 01.328.068 2.5 2.5 0 001.015.244c-.07.113-.142.225-.215.334-.254.058-.646-.02-.963-.192a.752.752 0 00-.437-.1 1.2 1.2 0 00-.382.111l-.082.037c-.1.046-.261.119-.33.147l.058-.011c-.396.153-.743.04-.843-.124-.176-.292-1.103-.149-1.364.186-.07.09-.279.105-.625.019zm.345.409l.059.059c.903.88 2.02 1.312 2.02 1.312s1.33-.402 2.084-1.25a4.41 4.41 0 00.193-.233 2.02 2.02 0 01-.84-.246.455.455 0 00-.268-.064.94.94 0 00-.288.087l-.024.01c-.077.035-.31.14-.449.188l.057-.012c-.467.195-.963.041-1.156-.25a.324.324 0 00-.078-.017 1.158 1.158 0 00-.288.012c-.23.036-.43.12-.496.205-.112.143-.287.206-.526.199z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.146 5.886h-.703l.546-.51-.546-.54h.703l.297-.524.298.524h.702l-.518.507.46.543h-.644l-.298.553-.297-.553zM10.46 5.886h-.702l.545-.51-.545-.54h.703l.297-.524.298.524h.702l-.518.507.46.543h-.644l-.298.553-.297-.553zM8.6 7.567h-.704l.546-.51-.546-.54H8.6l.296-.525.299.524h.701l-.518.508.46.543h-.643l-.299.553-.296-.553z",
      fill: "#FECA00"
    }
  )))
), a = t;
export {
  a as default
};
